import { render, staticRenderFns } from "./UpcomingAntragsbuchCard.vue?vue&type=template&id=e90df19a&scoped=true"
import script from "./UpcomingAntragsbuchCard.vue?vue&type=script&lang=ts"
export * from "./UpcomingAntragsbuchCard.vue?vue&type=script&lang=ts"
import style0 from "./UpcomingAntragsbuchCard.vue?vue&type=style&index=0&id=e90df19a&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e90df19a",
  null
  
)

export default component.exports